import * as React from 'react'
import {FC, memo, useState} from 'react'
import Form from 'antd/lib/form'
import 'antd/lib/form/style'
import Row from 'antd/lib/row'
import 'antd/lib/row/style'
import Col from 'antd/lib/col'
import 'antd/lib/col/style'
import CalcCard from '../../../../common/components/calc-card'
import Select from 'antd/lib/select'
import 'antd/lib/select/style'
import Input from 'antd/lib/input'
import 'antd/lib/input/style'
import IDS from '../../constants/ids'
import Radio from 'antd/lib/radio'
import 'antd/lib/radio/style'
import {STANDARD_ITEM_RULES_SELECT, STANDARD_ITEM_RULES} from '../../../../common/constants'
import {ProgramInfo} from '../../types/models/program-info'
import {COMPONENT_SIZE} from '../../constants'
import {FormInstance} from 'antd/lib/form'
import LABELS from '../../constants/labels'
import './index.less'
import Date from "../../../../../common/components/custom-form-components/date";
import {DatePicker} from "antd";

interface DistancePropsInterface {
    onValueChange: (fieldName: string | string[]) => void
    programInfo: ProgramInfo
    form: FormInstance
}

const {Item} = Form,
    {Option} = Select,
    {Group, Button} = Radio

const Distance: FC<DistancePropsInterface> = memo(({onValueChange, programInfo, form}) => {
    const [area, setArea] = useState('russia')

    const handleAreaChange = event => {
        setArea(event.target.value)
        form.setFieldsValue({[IDS.DISTANCE_COUNT]: null})
        onValueChange(IDS.DISTANCE_AREA)
    }

    const handleCountChange = event => {
        onValueChange(IDS.DISTANCE_COUNT)
    }

    return (
        <CalcCard>
            <h2>Расстояние</h2>
            <Row gutter={24}>
                <Col>
                    <Item
                        name={'beginDate'}
                        label={'Дата начала'}
                        rules={STANDARD_ITEM_RULES}
                    >
                        <DatePicker format='DD.MM.YYYY'/>
                    </Item>
                </Col>
                <Col>
                    <Item
                        name={'endDate'}
                        label={'Дата окончания'}
                        rules={STANDARD_ITEM_RULES}
                    >
                        <DatePicker format='DD.MM.YYYY'/>
                    </Item>
                </Col>
            </Row>
            <Row gutter={{xs: 24, sm: 24, md: 24, xl: 24}}>
                <Col xs={24} sm={8} md={12} lg={8}>
                    <Item
                        name={IDS.DISTANCE_AREA}
                        label={LABELS.DISTANCE_AREA}
                        rules={STANDARD_ITEM_RULES_SELECT}
                        initialValue='russia'
                    >
                        <Group buttonStyle='solid' onChange={handleAreaChange}>
                            {Object.keys(programInfo.distance).map((key, index) => (
                                <Button
                                    value={key}
                                    key={`distance-${key}`}
                                    className='e-distance__button'
                                >
                                    {key === 'russia'
                                        ? 'только Россия'
                                        : key === 'world'
                                        ? 'Россия и Мир'
                                        : 'Неизвестно'}
                                </Button>
                            ))}
                        </Group>
                    </Item>
                </Col>
                <Col xs={24} sm={16} md={12} lg={16}>
                    <Item
                        name={IDS.DISTANCE_COUNT}
                        label={LABELS.DISTANCE_COUNT}
                        rules={STANDARD_ITEM_RULES_SELECT}
                        required
                    >
                        {area === 'russia' ? (
                            <Select
                                className='e-full-wide'
                                placeholder='Выберите расстояние'
                                size={COMPONENT_SIZE}
                                onChange={handleCountChange}
                            >
                                {programInfo.distance.russia.map((distanceStamp, index) => (
                                    <Option
                                        value={distanceStamp.count}
                                        key={`distance-${distanceStamp.count}`}
                                    >
                                        {'до ' + distanceStamp.count + ' км'}
                                    </Option>
                                ))}
                            </Select>
                        ) : (
                            <Select
                                className='e-full-wide'
                                placeholder='Выберите расстояние'
                                size={COMPONENT_SIZE}
                                onChange={handleCountChange}
                            >
                                {programInfo.distance.world.map((distanceStamp, index) => (
                                    <Option
                                        value={distanceStamp.count}
                                        key={`distance-${distanceStamp.count}`}
                                    >
                                        {distanceStamp.count > 5000
                                            ? 'свыше ' + 5000 + ' км'
                                            : 'до ' + distanceStamp.count + ' км'}
                                    </Option>
                                ))}
                            </Select>
                        )}
                    </Item>
                </Col>
            </Row>
            <Row gutter={{xs: 24, sm: 24, md: 24, xl: 24}}>
                <Col xs={24} sm={12} md={12}>
                    <Item
                        name={IDS.DISTANCE_FROM}
                        label={LABELS.DISTANCE_FROM}
                        rules={STANDARD_ITEM_RULES}
                        required
                    >
                        <Input size={COMPONENT_SIZE} />
                    </Item>
                </Col>
                <Col xs={24} sm={12} md={12}>
                    <Item
                        name={IDS.DISTANCE_TO}
                        label={LABELS.DISTANCE_TO}
                        rules={STANDARD_ITEM_RULES}
                        required
                    >
                        <Input size={COMPONENT_SIZE} />
                    </Item>
                </Col>
            </Row>
        </CalcCard>
    )
})

export default Distance
